import React from "react";
import { useTranslation } from "react-i18next";
import MinimalAreaChart from "common/components/AreaChart/MinimalAreaChart";
import {
  ReportsCompletedByRoles,
  ReportsCompletedData,
} from "pages/Dashboards/types";
import {
  controllersStrings,
  getChartLineColor,
  getMinimalAreaChartData,
  periodAverageStrings,
  periodStrings,
} from "./utils";
import Trend from "../Components/Trend";

type Props = {
  data: ReportsCompletedByRoles;
  total: number;
  period: string;
};

const ReportsCompletedPerRole = ({ data, total, period }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="completed-per-role-container">
      <div className="completed-per-role-title">
        {`${t("reportsThatCompleted")} ${periodStrings[period]} `}
        {total && <span className="total-amount">{`(${total})`}</span>}
      </div>

      <div className="per-role-data-container">
        {Object.keys(data).map((key) => {
          const dataPerRole: ReportsCompletedData = data[key];
          const chartData = getMinimalAreaChartData(
            dataPerRole?.chartData || []
          );
          const chartLineColor = getChartLineColor(key);

          return (
            <div key={key} className="data-box">
              <div className="dashed-inner-border">
                <div className="controller-type">{controllersStrings[key]}</div>
                <MinimalAreaChart
                  data={chartData}
                  gradientLineColor={chartLineColor}
                />
                <div className="reports-amount">
                  {dataPerRole.reportCompleted}
                  {`  `}
                  <span>{t("reports")}</span>
                </div>
                <Trend
                  isIncrease={dataPerRole.trendIsIncrease}
                  isPercentage
                  amount={dataPerRole.percentageByCompleteOrNot}
                  trendPercent={dataPerRole.trendPercentageByPeriod}
                  periodAverageTitle={periodAverageStrings[period]}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default ReportsCompletedPerRole;
